import React from "react";
import { Link } from "react-router-dom";

export const About = ({ aboutdata }) => {
  const title1 = aboutdata?.title1 || "Who We Are ?";
  const desc1 =
    aboutdata?.description1 ||
    "Config Server LLP is a leading IT solutions provider specializing in web, mobile, and cloud-based development.";
  const title2 = aboutdata?.title2 || "What We Do ?";
  const desc2 =
    aboutdata?.description2 ||
    "We deliver innovative and scalable digital solutions tailored to meet the unique needs of businesses worldwide.";

  return (
    <section id="about" className="about-section">
      {/* Background Image directly from public folder */}
      <div
        className="about-bg"
        style={{
          backgroundImage: "url('../images/istockphoto-1334591614-612x612.jpg')", // ✅ direct path
        }}
      ></div>

      {/* Content */}
      <div className="about-content">
        <h2>{title1}</h2>
        <p>{desc1}</p>

        {/* <h2>{title2}</h2>
        <p>{desc2}</p> */}
         <div className="about-buttons">
          <Link to="/services" className="btn btn-primary">
            Find Our Services
          </Link>
          <Link to="/contact" className="btn btn-secondary">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};
